import React from "react";
import { cn } from "../../../lib/utils";

interface ConflictIndicatorProps {
  hasConflict: boolean;
  position?: "top-right" | "bottom-right";
  className?: string;
}

export const ConflictIndicator: React.FC<ConflictIndicatorProps> = ({
  hasConflict,
  position = "bottom-right",
  className,
}) => {
  if (!hasConflict) return null;

  const positionClasses = {
    "top-right": "top-2 right-2",
    "bottom-right": "bottom-2 right-2",
  };

  return (
    <div
      className={cn(
        "absolute bg-black text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold",
        positionClasses[position],
        className
      )}
    >
      !
    </div>
  );
};
